import type {
    PaymentProvider} from "@@/shared/payments/payment-providers";
import {
    paymentProviderZodSchema,
} from "@@/shared/payments/payment-providers";
import type { Price} from "@@/shared/prices/price";
import { priceZodSchema } from "@@/shared/prices/price";
import type {
    Translatable} from "@@/shared/translations/translation";
import {
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { z } from "zod";

type MonthlyTotals = {
    readonly sales: {
        paymentProvider: PaymentProvider;
        price: Price;
    }[];
    readonly fees: {
        readonly title: Translatable;
        readonly description?: Translatable;
        readonly price: Price;
    }[];
};

const monthlyTotalsZodSchema: z.ZodSchema<MonthlyTotals> = z.object({
    sales: z.array(
        z.object({
            paymentProvider: paymentProviderZodSchema,
            price: priceZodSchema,
        })
    ),
    fees: z.array(
        z.object({
            title: translatableZodSchema,
            description: translatableZodSchema.optional(),
            price: priceZodSchema,
        })
    ),
});

export type { MonthlyTotals };
export { monthlyTotalsZodSchema };
